// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3yA2j","questions":"styles_questions__2bhte","footer":"styles_footer__qTUQ_"};